<template>
  <div class="page-table scrollable only-y">
    <div class="no-table-box page-header">
      <el-row class="hidden-sm-and-up pb-15">
        <h1>
          <v-svg class="voxo-dark-red" sprite="call-block" />
          Do Not Call Lists
        </h1>
      </el-row>
      <el-row class="hidden-xs-only pb-15">
        <el-col :span="12">
          <h1>
            <v-svg class="voxo-dark-red" sprite="call-block" />
            Do Not Call Lists
          </h1>
        </el-col>

        <el-col class="text-right" :span="12">
          <el-tag>
            <i class="el-icon-info" style="margin-right: 4px" />
            Total: {{ total }}
          </el-tag>
        </el-col>
      </el-row>
      <div class="flex pb-20">
        <div class="box">
          <el-input v-model="search" placeholder="Search" clearable> </el-input>
          <el-button
            class="ml-10 hidden-xs-only"
            @click="doExport"
          >
            Export
          </el-button>
        </div>
        <div class="box right">
          <el-button @click="createVisible = true">Add New</el-button>
        </div>
      </div>
      <div class="vxe-table-height card-base card-shadow--medium">
        <vxe-grid
          round
          border="inner"
          ref="xGrid"
          height="100%"
          auto-resize
          empty-text="No Data"
          show-overflow="tooltip"
          highlight-hover-row
          @cell-click="cellClicked"
          @cell-mouseenter="rowHover"
          @cell-mouseleave="rowLeave"
          :data="tableData"
          :scroll-y="{enabled: true, gt: 50, oSize: 0}"
          :loading="tableLoading"
          :columns="tableColumns"
        />
      </div>
    </div>

    <!-- ⭐ CREATE FORM ⭐ -->
    <create-form
      :createVisible="createVisible"
      @closeModal="closeModal('create')"
    />

    <!-- ⭐ EDIT FORM ⭐ -->
    <edit-form
      :editVisible="editVisible"
      :selectedDoNotCall="selectedDoNotCall"
      @closeModal="closeModal('edit')"
    />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { debounce } from 'lodash';
import feathersClient from "../../../feathers/feathers-client";
import createForm from "./components/createForm.vue";
import editForm from "./components/editForm.vue";
import {globalEventBus} from "../../../globalEventBus";
import {ExportToCsv} from "export-to-csv";

export default {
  name: "DonotcallsTable",

  components: { createForm, editForm },

  data() {
    return {
      dncChannel: null,
      tableData: [],
      allDNCs: [],
      search: "",
      visibleActionsId: "",
      createVisible: false,
      selectedDoNotCall: null,
      editVisible: false,
      total: 0,
      tableLoading: false,
      tableColumns: [
        {
          field: 'sprite',
          title: '',
          width: 50,
          slots: {
            default: ({row}) => {
              return [
                <div class="voxo-square-icon voxo-bg-btn">
                  <v-svg class="voxo-red" sprite="call-block"/>
                </div>
              ]
            }
          }
        },
        {
          field: 'name',
          title: 'Name',
          minWidth: 150,
          sortable: true,
          showOverflow: true
        },
        {
          field: 'description',
          title: 'Description',
          minWidth: 300,
          sortable: true,
          showOverflow: true
        },
        {
          field: 'actions',
          title: '',
          minWidth: '150',
          showOverflow: false,
          slots: {
            default: ({row}) => {
              return [
                <div v-show={row.id === this.visibleActionsId}>
                  <el-button
                    id={'edit-'+ row.id}
                    icon="el-icon-edit"
                    onClick={() => this.openEditModal(row.id)}
                    class="table-action-button icon-blue"
                  />
                  <el-button
                    id={'delete-'+row.id}
                    icon="el-icon-delete"
                    onClick={() => this.deleteOperation(row.id)}
                    class="table-action-button icon-red"
                  />
                </div>
              ]
            }
          }
        }
      ]
    };
  },

  computed: {
    selectedTenant() {
      return this.$store.state.selectedTenant;
    },
    user() {
      return this.$store.state.auth.user;
    }
  },

  watch: {
    selectedTenant() {
      this.findDNCs();
      feathersClient.service('channel-memberships').remove(null ,{query: {channelName: this.dncChannel}});
      this.joinSocketChannel();
    },

    user() {
      this.findDNCs();
      if(!this.dncChannel){
        this.joinSocketChannel();
      }
    },

    search: debounce(function () {
      this.searchDNCs();
    }, 500)
  },

  methods: {
    ...mapActions("donotcalls", {
      createDonotcalls: "create",
      patchDonotcalls: "patch",
      deleteDonotcalls: "remove"
    }),

    doExport(){
      const data = [...this.tableData];
      if(data.length){

        const writeData = data.map(item => ({
          name: item.name,
          description: item.description
        }));

        const options = {
          filename: 'dnc_lists',
          showLabels: true,
          headers: ['Name', 'Description']
        }

        const csvExporter = new ExportToCsv(options);
        csvExporter.generateCsv(writeData);
      }
    },

    searchDNCs() {
      if(this.search.length){
        this.tableData = this.allDNCs.filter(
          data =>
            data.name.toString().toLowerCase().includes(this.search.toLowerCase()) ||
            data.description.toLowerCase().includes(this.search.toLowerCase())
        );
      } else{
        this.tableData = [...this.allDNCs];
      }
      this.total = this.tableData.length;
    },

    //General Form and Table Operations
    cellClicked(data){
      if(data.column.property !== 'actions'){
        this.openEditModal(data.row.id);
      }
    },

    rowHover(data){
      this.visibleActionsId = data.row.id;
    },

    rowLeave(){
      this.visibleActionsId = "";
    },

    openEditModal(id) {
      feathersClient.service("donotcalls").get(id).then(res => (this.selectedDoNotCall = res));
      this.editVisible = true;
    },

    findDNCs(){
      this.tableLoading = true;
      feathersClient.service('donotcalls').find({
        query: {
          tenantId: this.selectedTenant.id
        }
      }).then(res => {
        this.tableData = [...res];
        this.allDNCs = [...res];
        this.total = res.length;
        this.tableLoading = false;
      }).catch( () => {
        this.tableLoading = false;
      });
    },

    deleteOperation(id) {
      this.$confirm("Process do not call delete?", "Warning", {
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        type: "warning"
      })
        .then(() => {
          this.tableLoading = true;
          this.deleteDonotcalls(id)
            .then(() => {
              this.$notify({
                title: "Success",
                message: "Deleted successfully!",
                type: "success"
              });
              this.tableLoading = false;
            })
            .catch(error => {
              if (error.hasOwnProperty("errors")) {
                this.$notify({
                  title: error.message,
                  message: error.errors[Object.keys(error.errors)[0]],
                  type: "error"
                });
              } else {
                this.$notify({
                  title: error.name,
                  message: error.message,
                  type: "error"
                });
              }
              this.tableLoading = false;
            });
        })
        .catch(() => true);
    },

    closeModal(type) {
      if (type === "create") {
        this.createVisible = false;
      } else if (type === "edit") {
        this.editVisible = false;
      }
    },

    joinSocketChannel(){
      const channelService = feathersClient.service('channel-memberships');
      const data = {
        roomType: 'admins',
        tenantId: this.selectedTenant.id
      };
      channelService.create(data).then(res => {this.dncChannel = `${data.roomType}/${data.tenantId}`});
    },

    removeListeners(){
      feathersClient.service('donotcalls').removeListener('patched');
      feathersClient.service('donotcalls').removeListener('created');
      feathersClient.service('donotcalls').removeListener('removed');
      globalEventBus.$off('appReconnected');
    }

  },
  created(){
    //event listeners
    //monitor socket connection and reconnect to channel
    globalEventBus.$on('appReconnected', () => {
      this.joinSocketChannel();
    });

    //record was edited
    //always refresh did destination options
    feathersClient.service('donotcalls').on('patched', (data) => {
      const updateIndex = this.tableData.findIndex(item => item.id === data.id);
      const updateAllIndex = this.allDNCs.findIndex(item => item.id === data.id);
      if(updateIndex >= 0){this.tableData.splice(updateIndex, 1, data);}
      if(updateAllIndex >= 0){ this.allDNCs.splice(updateAllIndex, 1, data);}
    });

    //record was created
    feathersClient.service('donotcalls').on('created', (data) => {
      this.tableData.push(data);
      this.allDNCs.push(data);
    });

    //record was deleted
    feathersClient.service('donotcalls').on('removed', (data) => {
      const indexToRemove = this.tableData.findIndex(item => item.id === data.id);
      const indexAllToRemove = this.allDNCs.findIndex(item => item.id === data.id);
      if(indexToRemove >= 0){this.tableData.splice(indexToRemove, 1);}
      if(indexAllToRemove >= 0){this.allDNCs.splice(indexAllToRemove, 1);}
    });
  },
  mounted() {
    if (this.user) {
      this.findDNCs();
      this.joinSocketChannel();
    }
  },

  beforeDestroy() {
    this.removeListeners();
    feathersClient.service('channel-memberships').remove(null, {query: {channelName: this.dncChannel}});
    this.$store.commit('donotcalls/clearList')
  }
};
</script>
